var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_5_1",
    "data-name": "Component 5 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    fill: "none",
    stroke: "#b4b4b4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 75.5,
    r: 75.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 75.5,
    r: 74.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264",
    transform: "translate(36.845 42.766)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 27.633,
    y2: 27.633,
    transform: "translate(0 30.265)",
    fill: "none",
    stroke: "#b4b4b4",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 50.003,
    y2: 57.899,
    transform: "translate(27.633)",
    fill: "none",
    stroke: "#b4b4b4",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirmation);
export default __webpack_public_path__ + "static/media/emailConfirmation.d251a362d9e5b8a2ec03231036a84935.svg";
export { ForwardRef as ReactComponent };